var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrowSub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 54,
    viewBox: "0 0 71 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20758 23.8702L24.3017 3.09689C26.905 0.752909 31.3589 2.41493 31.3589 5.72673V20.3746H63.8489C67.559 20.3746 71 23.1147 71 26.5C71 29.8853 67.5593 32.6254 63.8492 32.6254H31.3634V47.2733C31.3634 50.5851 26.9095 52.2471 24.3061 49.9031L1.21206 29.1298C-0.401035 27.6761 -0.405509 25.3239 1.20758 23.8702Z",
    fill: "#4995FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowSub);
export default __webpack_public_path__ + "static/media/left-arrow-sub.cf7d9699485726505ee6f6c9700b8c3f.svg";
export { ForwardRef as ReactComponent };